<template>
    <div
        class="account_table table-responsive mt_30 order_tabel my_account_order_table_custom orders_table"
    >
        <table
            class="table"
            :class="[
                all_orders_list.length < 1 ? 'my-order-empty-tabel' : '',
                ispopupopen
            ]"
        >
            <thead>
                <tr>
                    <th class="order_id_column" scope="col">ORDER ID</th>
                    <th scope="col">ORDER DATE</th>
                    <th scope="col">NETSUITE SO NUMBER</th>
                    <th scope="col" v-if="!listConfig.order_status">
                        SERVICES
                    </th>
                    <th scope="col" v-if="!listConfig.order_status">CS REP</th>
                    <th scope="col">ARTWORKS / DESIGNS</th>
                    <th scope="col">TOTAL QUANTITY</th>
                    <th
                        scope="col"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        ADDITIONAL CHARGES
                    </th>
                    <th
                        scope="col"
                        v-if="listConfig.order_status != 'INREVIEW'"
                    >
                        TOTAL COST
                    </th>
                    <th
                        scope="col"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        TOTAL DUE
                    </th>
                    <th class="status_btn" scope="col">STATUS</th>
                    <th scope="col" v-if="!listConfig.order_status">STATE</th>
                    <th scope="col" v-if="!listConfig.order_status">
                        LAST UPDATE
                    </th>
                    <th
                        scope="col"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        PAYMENT STATUS
                    </th>
                    <th
                        scope="col"
                        v-if="
                            ['INREVIEW', 'COMPLETED'].includes(
                                listConfig.order_status
                            )
                        "
                    >
                        ACTION
                    </th>
                </tr>
            </thead>
            <tbody v-for="(order, indx) in all_orders_list" :key="indx">
                <tr>
                    <td name="ORDER ID">
                        <a class="track_link" href="javascript:void(0);">
                            <div class="track_id d-flex">
                                <div class="track_id_content">
                                    <router-link
                                        v-if="
                                            ['INREVIEW'].includes(
                                                listConfig.order_status
                                            )
                                        "
                                        :to="{
                                            name: 'OrderProofReview',
                                            params: { id: order.id }
                                        }"
                                        >{{ order.unique_order_id }}
                                    </router-link>
                                    <router-link
                                        v-else
                                        :to="{
                                            name: 'Order_detail',
                                            params: { id: order.id }
                                        }"
                                        >{{ order.unique_order_id }}
                                    </router-link>
                                </div>
                            </div>
                        </a>
                    </td>

                    <td name="ORDER DATE">
                        {{ order.created_at | formatDate }}
                    </td>
                    <td name="SO NUMBER" class="align-items-center">
                        {{
                            order.netsuite_so_number
                                ? order.netsuite_so_number
                                : "-"
                        }}
                    </td>

                    <td name="SERVICES" v-if="!listConfig.order_status">
                        <span
                            v-tooltip="order.services.join(', ')"
                            v-if="order.services && order.services.length > 0"
                            >{{ order.services.join(", ") }}</span
                        >
                        <span v-else>-</span>
                    </td>

                    <td name="CS REP" v-if="!listConfig.order_status">
                        <span v-if="order.AssignedToUser"
                            >{{ order.AssignedToUser.first_name }}
                            {{ order.AssignedToUser.last_name }}</span
                        >
                        <span v-else>-</span>
                    </td>

                    <td
                        name="ARTWORKS / DESIGNS"
                        v-on:click="
                            showArtworks(
                                order.unique_order_id,
                                order.total_artwork_count !== undefined && order.total_artwork_count > 0 ? order.total_artwork_count : 0
                            )
                        "
                    >
                        <span
                            class="art_work_no_custom"
                            :style="
                                order.total_artwork_count !== undefined && order.total_artwork_count > 0 ? 'cursor:pointer;' : ''
                            "
                            >{{ order.total_artwork_count !== undefined && order.total_artwork_count > 0 ? order.total_artwork_count : 0 }}</span
                        >
                    </td>

                    <td name="TOTAL QUANTITY">
                        {{ Number(order.total_quantity) }}
                    </td>

                    <td
                        name="ADDITIONAL CHARGES"
                        class="addi_chrges"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        <div v-if="order.additional_payment_status != 'PAID'">
                            <span
                                v-if="
                                    order.modified_fees &&
                                    Object.keys(order.modified_fees).length > 0
                                "
                            >
                                <span v-if="order.modified_fees.color_fees">
                                    Additional Color Fees :
                                    {{
                                        icPriceFormat(
                                            order.modified_fees.color_fees
                                        )
                                    }}
                                </span>
                                <span v-else-if="order.modified_fees.item_fees">
                                    Item Fees :
                                    {{
                                        icPriceFormat(
                                            order.modified_fees.item_fees
                                        )
                                    }}
                                </span>
                                <span
                                    v-else-if="order.modified_fees.order_fees"
                                >
                                    Order Fees :
                                    {{
                                        icPriceFormat(
                                            order.modified_fees.order_fees
                                        )
                                    }}
                                </span>
                                <span v-else> -- </span>
                            </span>
                            <span v-else>--</span>
                            <div
                                class="dropdown"
                                v-if="
                                    order.modified_fees &&
                                    Object.keys(order.modified_fees).length > 1
                                "
                            >
                                <a
                                    href="#"
                                    class="dropdown-toggle d-flex align-items-center"
                                    :id="'dropdownMenuButton' + order.id"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    +{{
                                        Object.keys(order.modified_fees)
                                            .length - 1
                                    }}
                                </a>
                                <div
                                    class="dropdown-menu drop-cart-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <h4
                                        class="font_size_16 text_primary_blue py_2 px_20"
                                    >
                                        Modified Fees
                                        <span class="cross_ic">
                                            <img
                                                src="/maincss/images/cross.svg"
                                            />
                                        </span>
                                    </h4>
                                    <div class="scroll">
                                        <div
                                            v-if="
                                                order.modified_fees.color_fees
                                            "
                                            class="dropdown-item d-flex align-items-center"
                                        >
                                            <p class="font-weight-bold w-25">
                                                Additional Color Fees:
                                            </p>

                                            <p class="ml-auto">
                                                {{
                                                    icPriceFormat(
                                                        order.modified_fees
                                                            .color_fees
                                                    )
                                                }}
                                            </p>
                                        </div>
                                        <div
                                            v-if="order.modified_fees.item_fees"
                                            class="dropdown-item d-flex align-items-center"
                                        >
                                            <p class="font-weight-bold w-25">
                                                Item Fees:
                                            </p>

                                            <p class="ml-auto">
                                                {{
                                                    icPriceFormat(
                                                        order.modified_fees
                                                            .item_fees
                                                    )
                                                }}
                                            </p>
                                        </div>
                                        <div
                                            v-if="
                                                order.modified_fees.order_fees
                                            "
                                            class="dropdown-item d-flex align-items-center"
                                        >
                                            <p class="font-weight-bold w-25">
                                                Order Fees:
                                            </p>

                                            <p class="ml-auto">
                                                {{
                                                    icPriceFormat(
                                                        order.modified_fees
                                                            .order_fees
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span v-else>--</span>
                    </td>

                    <td
                        name="TOTAL COST"
                        v-if="listConfig.order_status != 'INREVIEW'"
                    >
                        {{ icPriceFormat(order.total_price) }}
                    </td>

                    <td
                        name="TOTAL DUE"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        {{ icPriceFormat(order.total_due) }}
                    </td>

                    <td name="STATUS">
                        <div class="table_btn">
                            <a
                                v-if="order.status == 'NEW'"
                                href="javascript:void(0)"
                                class="btn purple_color"
                                >New</a
                            >
                            <div
                                v-else-if="order.status == 'INREVIEW'"
                                class="proof_review_btn d-flex"
                            >
                                <router-link
                                    :to="{
                                        name: 'OrderProofReview',
                                        params: { id: order.id }
                                    }"
                                    class="btn orange_color orange_bg"
                                    >Proof Review</router-link
                                >
                                <p>
                                    <img
                                        src="/maincss/images/star.svg"
                                        alt="star"
                                    />
                                </p>
                            </div>
                            <router-link
                                v-else-if="order.status == 'APPROVED'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                Approved
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'REDESIGN'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                Redesign
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'PRODUCTION'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                Production
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'COMPLETED'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                Completed
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'PENDING AMOUNT'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                Pending Amount
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'IN SHIPMENT'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn green_color"
                            >
                                In Shipment
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'OPEN ORDERS'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn orange_bg"
                            >
                                Open Orders
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'ON HOLD'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn orange_bg"
                            >
                                On Hold
                            </router-link>
                            <router-link
                                v-else-if="order.status == 'BACK ORDER'"
                                :to="{
                                    name: 'OrderProofReview',
                                    params: { id: order.id }
                                }"
                                class="btn orange_bg"
                            >
                                BACK ORDER
                            </router-link>
                        </div>
                    </td>

                    <td name="STATE" v-if="!listConfig.order_status">
                        <div class="d-flex align-center">
                            <div
                                class="chat_box"
                                style="cursor: pointer"
                                v-tooltip="parseActivityText(order.activity)"
                            >
                                <img src="/maincss/images/chat.svg" alt=" " />
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'NEW'"
                                    >N</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'INREVIEW'"
                                    >IR</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'OPEN ORDERS'"
                                    >O</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'ON HOLD'"
                                    >OH</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'APPROVED'"
                                    >A</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'REDESIGN'"
                                    >RD</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'COMPLETED'"
                                    >C</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'PRODUCTION'"
                                    >P</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'PENDING AMOUNT'"
                                    >PA</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'IN SHIPMENT'"
                                    >IS</span
                                >
                                <span
                                    class="notifiction_icon blue"
                                    v-if="order.status == 'BACK ORDER'"
                                    >B</span
                                >
                            </div>
                        </div>
                    </td>

                    <td name="LAST UPDATE" v-if="!listConfig.order_status">
                        <div class="d-flex align-center">
                            <span v-if="order.updated_at">
                                {{
                                    new Date(order.updated_at)
                                        .toLocaleDateString(
                                            "en-US",
                                            timestampOptions
                                        )
                                        .split(",")[0]
                                }}
                                <span class="time">{{
                                    new Date(order.updated_at)
                                        .toLocaleDateString(
                                            "en-US",
                                            timestampOptions
                                        )
                                        .split(",")[1]
                                }}</span>
                            </span>
                            <span v-else>-</span>

                            <a
                                class="dropdown-toggle three_dots p-2"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                id="dropdownMenuLink"
                            >
                                <img src="/maincss/images/threedots.svg" />
                            </a>
                            <div
                                class="dropdown-menu after_value_none"
                                aria-labelledby="dropdownMenuLink"
                                style="top: 41px !important"
                            >
                                <router-link
                                    class="dropdown-item"
                                    :to="{
                                        name: 'Order_detail',
                                        params: { id: order.id }
                                    }"
                                >
                                    Order Details
                                </router-link>
                                <router-link
                                    v-if="
                                        ['INREVIEW', 'APPROVED'].includes(
                                            order.status
                                        )
                                    "
                                    class="dropdown-item"
                                    :to="{
                                        name: 'OrderProofReview',
                                        params: { id: order.id }
                                    }"
                                >
                                    Order Review Proof
                                </router-link>
                                <a
                                    v-if="['COMPLETED'].includes(order.status)"
                                    href="javascript:void(0);"
                                    @click="$emit('reOrder', order)"
                                    class="dropdown-item"
                                >
                                    Reorder
                                </a>
                            </div>
                        </div>
                    </td>

                    <td
                        name="PAYMENT STATUS"
                        scope="col"
                        v-if="listConfig.order_status == 'INREVIEW'"
                    >
                        <div class="table_btn">
                            <a
                                v-if="
                                    order.additional_payment_status == 'PENDING'
                                "
                                href="javascript:void(0);"
                                class="btn red_color"
                            >
                                Pending
                            </a>
                            <a
                                v-else-if="
                                    order.additional_payment_status == 'FAILED'
                                "
                                href="javascript:void(0);"
                                class="btn red_color"
                            >
                                Failed
                            </a>
                            <a
                                v-else-if="
                                    order.additional_payment_status == 'PAID'
                                "
                                href="javascript:void(0);"
                                class="btn green_color"
                            >
                                Paid
                            </a>
                            <a
                                v-else
                                href="javascript:void(0);"
                                class="btn green_color"
                            >
                                Paid
                            </a>
                        </div>
                    </td>

                    <td
                        name="ACTION"
                        scope="col"
                        v-if="
                            ['INREVIEW', 'COMPLETED'].includes(
                                listConfig.order_status
                            )
                        "
                    >
                        <div class="d-flex align-center">
                            <router-link
                                v-if="listConfig.order_status == 'INREVIEW'"
                                :class="{ disabled: order.total_due == 0 }"
                                :to="{
                                    name: 'AdditionalPayment',
                                    params: { order_id: order.id }
                                }"
                            >
                                <button class="pay_now_btn">Pay Now</button>
                            </router-link>

                            <button
                                v-else-if="
                                    listConfig.order_status == 'COMPLETED'
                                "
                                class="pay_now_btn"
                                @click="$emit('reOrder', order)"
                            >
                                Reorder
                            </button>

                            <a
                                class="dropdown-toggle three_dots p-2"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                id="dropdownMenuLink"
                            >
                                <img src="/maincss/images/threedots.svg" />
                            </a>
                            <div
                                class="dropdown-menu after_value_none order_info"
                                aria-labelledby="dropdownMenuLink"
                                style="top: 41px !important"
                            >
                                <router-link
                                    class="dropdown-item"
                                    :to="{
                                        name: 'Order_detail',
                                        params: { id: order.id }
                                    }"
                                >
                                    Order Details
                                </router-link>
                                <router-link
                                    v-if="
                                        ['INREVIEW', 'APPROVED'].includes(
                                            order.status
                                        )
                                    "
                                    class="dropdown-item"
                                    :to="{
                                        name: 'OrderProofReview',
                                        params: { id: order.id }
                                    }"
                                >
                                    Order Review Proof
                                </router-link>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td
                        colspan="12"
                        style="padding: 0px"
                        :id="`artworks-td-${order.unique_order_id}`"
                    >
                        <div
                            :id="`artworks${order.unique_order_id}`"
                            class="artwork d-none"
                        >
                            <div
                                class="box d-flex flex-wrap align-items-center"
                            >
                                <img
                                    v-for="(
                                        artwork, artwork_index
                                    ) in (order.artworks || [])"
                                    :key="artwork_index"
                                    :src="artwork.artwork"
                                    alt=""
                                />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="no-record" v-if="all_orders_list.length < 1">
                    <td colspan="12" class="text-center">No record Found</td>
                </tr>
            </tbody>
        </table>

        <p class="no-record" v-if="all_orders_list.length < 1">
            No record Found
        </p>
    </div>
</template>

<script>
export default {
    name: "OrderList",
    components: {},
    props: {
        listConfig: {
            required: true
        },
        all_orders_list: {
            required: true
        },
        reOrder: {
            required: false,
            default: () => {}
        }
    },
    data() {
        return {
            searchedKeyword: "",
            ispopupopen: "",
            hidePopup: false,
            timestampOptions: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true // Use 12-hour clock format
            }
        };
    },
    mounted() {
        var _this = this;
        /* eslint-disable */
        $(document).ready(function () {
            $("body").on("hide.bs.dropdown", function (event) {
                console.log(event.type, "qqqqqqq");
                _this.ispopupopen = _this.hidePopup ? "" : "order_tabel_height";
                _this.hidePopup = false;
            });
            $("body").on("show.bs.dropdown", function (event) {
                console.log(event.type, "wwwwwwwwww");
                _this.ispopupopen = "order_tabel_height";
                _this.hidePopup = true;
            });
        });
        /* eslint-enable */
    },
    methods: {
        openPopup() {
            this.ispopupopen = "order_tabel_height";
            this.hidePopup = true;
        },
        sorting($event) {
            var _this = this;

            _this.listConfig.sortBy == $event.sortBy;
            _this.listConfig.order == $event.order;
            console.log(_this.listConfig, $event);
            this.$emit("updatesorting", $event);
        },
        showArtworks(id, artworks_count) {
            var artworks = document.querySelectorAll(".artwork");
            artworks.forEach((element) => {
                if (element.id != "artworks" + id) {
                    element.classList.add("d-none");
                }
            });
            if (artworks_count == 0) {
                return;
            }
            const body = document.querySelector("body");
            if (body.classList.contains("safari-overflow-hidden")) {
                body.classList.remove("safari-overflow-hidden");
            } else {
                body.classList.add("safari-overflow-hidden");
            }
            /* eslint-disable */
            $(`#artworks${id}`).toggleClass("d-none");
            /* eslint-enable */
        },
        parseActivityText(json) {
            const activity = json ? JSON.parse(json) : [];
            if (activity.length == 0) {
                return "Order placed";
            }
            return activity[0];
        }
    }
};
</script>
<style scoped>
.dropdown-menu.after_value_none.show {
    top: 41px !important;
    left: -13px !important;
    border: unset;
}

@media only screen and (max-width: 1024px) {
    .my-order-empty-tabel {
        min-width: 1600px !important;
    }
}

@media only screen and (max-width: 1024px) {
    .my-order-empty-tabel {
        min-width: 1600px !important;
    }
}
</style>
